import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext'; // <--- Hinzufügen

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>  {/* <--- Hinzufügen */}
      <App />
    </AuthProvider> {/* <--- Hinzufügen */}
  </React.StrictMode>
);

reportWebVitals();